<!-- src/apps/workspace/dashboard/DashboardIndex.vue -->

<script setup lang="ts">
  import DashboardView from '@/apps/secret/components/dashboard/DashboardView.vue';
  import UpgradeBanner from '@/apps/workspace/dashboard/components/UpgradeBanner.vue';

  /**
   * `/dashboard` — the ported Figma Make dashboard. A signed-in visitor can
   * arrive here or stay on `/` (no guard redirects between them), so both
   * render the same DashboardView instead of drifting apart; only the
   * plan-upgrade banner is workspace-specific.
   *
   * This replaced the PrivacyOptionsBar + WorkspaceSecretForm pair, which had
   * no other caller and has been removed.
   */
</script>

<template>
  <!-- max-w-7xl matches the site header/footer pattern so the Enviados tab can
       use the full site width; DashboardView still caps the composer at 800px. -->
  <div class="container mx-auto max-w-7xl min-w-[320px] px-4">
    <!-- Upgrade Banner (shown for free plan users when billing is enabled) -->
    <UpgradeBanner />

    <DashboardView />
  </div>
</template>
